export const PURPOSES = [
    { id: "sales", label: "Sales" },
    { id: "support", label: "Support" },
    { id: "collections", label: "Collections" },
    { id: "renewal", label: "Renewal" },
    { id: "appointment_reminder", label: "Appointment Reminder" },
    { id: "survey", label: "Survey" },
];

export const DIAL_MODES = [
    { id: "preview", label: "Preview Dialer", desc: "Agent reviews each customer's details before the call is placed. Best for high-value, consultative outreach.", ready: true },
    { id: "power", label: "Power Dialer", desc: "Automatically dials the next record as soon as the agent finishes a call. Great for steady, high-volume calling.", ready: true },
    { id: "progressive", label: "Progressive Dialer", desc: "Dials the next number only when the assigned agent is free — minimises dropped calls.", ready: false },
    { id: "predictive", label: "Predictive Dialer", desc: "Dials multiple numbers at once and routes answered calls to the next available agent. Maximises talk time.", ready: true },
];

export const DATA_SOURCES = [
    { id: "csv", label: "CSV Upload", desc: "Upload a spreadsheet of records (needs a phone column).", ready: true },
    { id: "sf_contacts", label: "Existing Contacts", desc: "Pull Salesforce Contacts that have a phone number.", ready: true },
    { id: "sf_leads", label: "Existing Leads", desc: "Pull open Salesforce Leads that have a phone number.", ready: true },
    { id: "sf_report", label: "Salesforce Report", desc: "Import records from a saved Tabular report.", ready: true },
    { id: "sf_listview", label: "Salesforce List View", desc: "Import records from any object's list view.", ready: true },
    { id: "sf_campaign", label: "Salesforce Campaign Members", desc: "Dial the members of a Salesforce campaign.", ready: true },
];

export const STATUS_STYLES = {
    draft: "bg-stone-100 text-stone-600",
    active: "bg-emerald-100 text-emerald-700",
    paused: "bg-amber-100 text-amber-700",
    completed: "bg-sky-100 text-sky-700",
    archived: "bg-stone-200 text-stone-500",
};

export const AI_TOGGLES = [
    { id: "call_summary", label: "Generate AI Call Summary", desc: "Summarise every call automatically." },
    { id: "detect_sentiment", label: "Detect Customer Sentiment", desc: "Score how each conversation felt." },
];

export const labelFor = (list, id) => (list.find((x) => x.id === id) || {}).label || id || "—";
